import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/en/terms-conditions")({
  head: () => buildRouteHead("/en/terms-conditions", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ to: "/en/terms-and-conditions", replace: true });
  },
});
